import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const HeroSection = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true, // ✅ TURN ON AUTO SLIDE
    autoplaySpeed: 3000, // 4 sec
    speed: 1000, // transition speed
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: false,
  };

  return (
    <section className="hero-slider">
      <Slider {...settings}>
        {/* Slide 1 */}
        <div className="hero-slide">
          <div className="overlay"></div>
          <div className="hero-text">
            <h1>Experts in Capital Market Audits & NCLT Matters</h1>
            <p>
              Specialized advisory for Listed Companies, Intermediaries &
              Corporate Litigation — backed by deep regulatory and financial
              expertise.
            </p>

            <Link
              to="/about"
              className="apply-btn"
              onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
            >
              Consult Our Specialist Team
            </Link>
          </div>
        </div>

        {/* Slide 2 */}
        <div className="hero-slide">
          <div className="overlay1"></div>
          <div className="hero-text">
            <h1>End-to-End Compliance. Zero Regulatory Stress.</h1>
            <p>
              Tax Audit • Statutory Audit • GST • Income Tax • ROC & Corporate
              Compliance — accurate, timely, and fully compliant.
            </p>

            <Link
              to="/audit-assurance"
              className="apply-btn"
              onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
            >
              View Our Services
            </Link>
          </div>
        </div>

        {/* Slide 3 */}
        <div className="hero-slide">
          <div className="overlay2"></div>
          <div className="hero-text">
            <h1>Beyond Compliance Strategic Financial & Legal Advisory</h1>
            <p>
              Where statutory excellence meets high-impact advisory. Building
              compliant foundations for your next leap forward.
            </p>

            <Link
              to="/contactus"
              className="apply-btn"
              onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
            >
              Schedule a Discussion
            </Link>
          </div>
        </div>
      </Slider>
    </section>
  );
};

export default HeroSection;
